module.exports = __webpack_public_path__ + "img/gso-logo.2124ee1e.png";